module.exports = __webpack_public_path__ + "static/appInto06-eabc9fd9fe4eb554ad6d19f010cf568a.png";